import * as React from "react";

class ButtonDText extends React.Component {
  constructor(props: {}) {
    super(props);
  }

  public render() {
    return (
      <svg
        className="buttonD-text"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 244.741 88.204"
      >
        <path
          fill="#fcfaee"
          d="M95.7,42.93v10H92.62V51.65H76.85V43h3.07v6h4.83V41.73H78.06V33.4H81v5.69h3.79V31.47h3v7.62h4V33.4h3v8.33h-7V49h4.84v-6Z"
        />
        <path
          fill="#fcfaee"
          d="M119.6,35.28a28.57,28.57,0,0,1-2.71,2.11,16.44,16.44,0,0,0,3.29,1.29,9.44,9.44,0,0,0-1.63,2.16,15.84,15.84,0,0,1-2.62-1.1v2c0,.55,0,.74.34.74h1.13a5.05,5.05,0,0,0,1.17-.12c.05.55.09,1.33.18,1.86a4.38,4.38,0,0,1-1.33.14H116c-1.93,0-2.3-.78-2.3-2.64V40.36h-2.11a5.32,5.32,0,0,1-2.53,4.54,10.68,10.68,0,0,0-1.37-1.47v.69h-4.55c-.09.53-.16,1.08-.23,1.59h4.78s0,.62,0,.94c-.25,3.1-.53,4.59-1.13,5.19a2.41,2.41,0,0,1-1.83.76,24.2,24.2,0,0,1-3,0,5.15,5.15,0,0,0-.79-2.27c1.15.09,2.28.11,2.78.11a1,1,0,0,0,.83-.23c.28-.25.48-1,.64-2.55h-4.82c.32-1.49.69-3.76.9-5.58h4.06V40.49h-3.33v-.36a19,19,0,0,1-2.09.89,10.62,10.62,0,0,0-1.47-2,15.3,15.3,0,0,0,3.86-1.76,22.35,22.35,0,0,0-2.14-1.38l1.57-1.45a16.56,16.56,0,0,1,2.41,1.45,11.54,11.54,0,0,0,1.33-1.47h-4.53V32.27h6l.46-.11L109,33a12.9,12.9,0,0,1-4.31,5.45h3V43a3.31,3.31,0,0,0,1.62-3.08V38.29h4.39a15.87,15.87,0,0,1-4.64-6.09l2.18-.64a9.43,9.43,0,0,0,1.31,2.16,20.71,20.71,0,0,0,2.16-2.11l2,1.4c-.94.78-1.93,1.61-2.8,2.23.39.36.81.71,1.22,1a19.65,19.65,0,0,0,2.55-2.39Zm-1.67,10.15a10.3,10.3,0,0,1-2.53,4.09c1,.57,2,1.15,2.66,1.61l-1.37,1.81c-.78-.55-1.89-1.26-3.13-2a16.87,16.87,0,0,1-5.12,2,7.75,7.75,0,0,0-1.15-2,14.74,14.74,0,0,0,4.09-1.28c-1.12-.62-2.2-1.24-3.19-1.77l.92-1.1h-.55V45H116l.41-.07Zm-7.63,1.36c1,.5,2,1,3.06,1.6a8.73,8.73,0,0,0,1.44-1.6Z"
        />
        <path
          fill="#fcfaee"
          d="M141.16,32.53v8.22h-2.75v-6.3H125.94v6.32H123.3V32.53Zm-16.33,8.84h14.93V52.76H137v-.67h-9.55v.78h-2.65Zm12.59-4.07H127.06V35.51h10.36Zm-10.33,2.87V38.36H137.4v1.81Zm.39,3.13v1.05H137V43.3ZM137,47.2V46.14h-9.55V47.2Zm0,2.92V49h-9.55v1.11Z"
        />
        <path
          fill="#fcfaee"
          d="M154.94,37.33a22.63,22.63,0,0,1-2.27,1.4,13.82,13.82,0,0,0-1.68-1.8c-.25.85-.46,1.68-.69,2.39a8.26,8.26,0,0,1,1.4,4.73c0,1.52-.25,2.51-.92,3a2.36,2.36,0,0,1-1.22.5,7.86,7.86,0,0,1-1.33.07,6.28,6.28,0,0,0-.55-2.37,3.61,3.61,0,0,0,.85,0,.75.75,0,0,0,.53-.19c.25-.2.34-.71.34-1.4a7.06,7.06,0,0,0-1.28-4.15c.37-1.38.78-3.27,1.1-4.78h-1.68V52.85h-2.27V32.36h4.66l.37-.09,1.7,1-1,3.49a16.75,16.75,0,0,0,6.32-5.58l2.62.92c-.14.23-.28.48-.44.71A21.84,21.84,0,0,0,166,36.27a12.37,12.37,0,0,0-1,2.59,26.77,26.77,0,0,1-3.26-1.7v1.5h-6.75Zm1.49,9c-.14.46-.32.92-.5,1.35a16,16,0,0,1,2.18,1.66l-1.38,1.81a11.59,11.59,0,0,0-1.81-1.58A11.82,11.82,0,0,1,151.63,53a11.62,11.62,0,0,0-1.77-1.73A9.33,9.33,0,0,0,154,45.82Zm-4.18-6.53h5.54v5.77h-5.54Zm1.95,4h1.54V41.64H154.2Zm6.62-7.15a22.65,22.65,0,0,1-2.71-2.06,23.94,23.94,0,0,1-2.21,2.06Zm2,9.53a12.12,12.12,0,0,1-.53,1.86,30.92,30.92,0,0,1,3.56,2.76l-1.61,1.84a23.32,23.32,0,0,0-2.92-2.48A9.41,9.41,0,0,1,158.8,53a10.2,10.2,0,0,0-1.75-1.72,8,8,0,0,0,3.33-5.44Zm-4-6.34h5.69v5.77h-5.69Zm2,4h1.61V41.64h-1.61Z"
        />
      </svg>
    );
  }
}

export default ButtonDText;



// WEBPACK FOOTER //
// ./src/storyB/components/ButtonDText.tsx